export const conditionsDefault = { andConditions: [] };
export const qreIdDefault = '';
export const pagingDefault = { offset: 0, pageSize: 100 };
export const filterDefault = null;
export const sortingDefault = [];
//# sourceMappingURL=defaults.js.map